import React from "react";

const SuiviBudget = () => {
  return (
    <div className="suivi-budget">
      <h2>Suivi budgétaire</h2>
      <p>Tableau de suivi des budgets.</p>
    </div>
  );
};

export default SuiviBudget;
